import Card from "Components/Common/Card/Card";
import CardContent from "Components/Common/Card/CardContent/CardContent";
import CardImage from "Components/Common/Card/CardImage/CardImage";
import RouterLink from "Components/RouterLink/RouterLink";
import { RouterLinkType } from "Enums/RouterLinkType";
import { ChecklistTemplate } from "Models/Checklists/ChecklistTemplate";
import * as React from "react";
import ChecklistTemplateBlockDetailsBlock from "./ChecklistTemplateBlockDetailsBlock/ChecklistTemplateBlockDetailsBlock";

interface IProps {
    checklistTemplate: ChecklistTemplate;
}

const ChecklistTemplateBlockCard: React.FunctionComponent<IProps> = (props: IProps) => (
    <RouterLink to={`/checklisttemplates/${props.checklistTemplate.id}`} type={RouterLinkType.default}>
        <Card>
            <CardImage src={props.checklistTemplate.pictureUrl} />
            <CardContent>
                <ChecklistTemplateBlockDetailsBlock checklistTemplate={props.checklistTemplate} />
            </CardContent>
        </Card>
    </RouterLink>
);

export default ChecklistTemplateBlockCard;


// WEBPACK FOOTER //
// ./src/Components/Pages/CheckTemplateBlockOverview/ChecklistTemplateBlockView/ChecklistTemplateBlockCard/ChecklistTemplateBlockCard.tsx